import * as z from 'zod'

import { DOG_LIABILITY_NXT_CONSTANTS } from '@flows/configs/dogLiabilityNxt/constants'
import { DEDUCTIBLE_HEADER } from '@flows/configs/shared/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { TransformedOption } from '@flows/core/types/stepContentTypes'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_DogLiabilityV1GetsafeDe } from '@flows/insurance/schemas'
import Schema_Quote from '@flows/insurance/schemas/shared/Schema_Quote'

const dog_quote = (params: StepConfigParams) =>
  ({
    validationStrategy: 'onChange',
    schema: Schema_Quote.merge(
      schemaUtils.generateZodObjectFromPaths({
        [params.helperFunctions.getParamPath('sos_help_coverage')]:
          BaseSchema_DogLiabilityV1GetsafeDe.shape.sos_help_coverage,
        [params.helperFunctions.getParamPath('tariff_line')]:
          BaseSchema_DogLiabilityV1GetsafeDe.shape.tariff_line,
        product_keys: z.object({ dog_liability_v1_getsafe_de: z.boolean().optional() }).optional(),
      })
    ),
    stepContent: [
      {
        type: 'customComponent',
        name: 'QuoteStep',
        props: {
          product: 'dog_liability_v1_getsafe_de',
          configurableParameters: [
            DEDUCTIBLE_HEADER(),
            {
              type: 'dropDown',
              label: {
                type: 'translatableText',
                translationKey: 'sharedFlows_common:steps.deductibles',
              },
              useFilterInput: false,
              styleType: 'outlined',
              name: params.helperFunctions.getParamPath('deductible_amount'),
              options: DOG_LIABILITY_NXT_CONSTANTS.deductiblesOptions.map(
                (option): TransformedOption => {
                  return {
                    label: {
                      type: 'nonTranslatableText',
                      text: params.clientHelpers.formatter.formatCurrency(option),
                    },
                    value: Number(option),
                  }
                }
              ),
            },
          ],
        },
        inputs: [],
        outputs: [],
      },
    ],
    nextStep: 'dog_liability_personal_details',
    subFlow: params.subFlow,
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'prepareQuoteStep',
        options: {
          productKey: params.productKey,
        },
        inputs: [],
        outputs: [],
      },
    },
    showOrderSummary: true,
    nonStickyFooter: true,
  }) as const satisfies AnyStepConfiguration

export default dog_quote
